<template>
  <section class="legal-page">
    <div class="legal-shell">
      <aside class="legal-intro">
        <p class="eyebrow">Clear expectations</p>
        <h1>Tutoring<br>Terms</h1>
        <p class="updated">Last updated August 28, 2026</p>
      </aside>

      <div class="legal-content">
        <section>
          <span>01</span>
          <h2>Business and services</h2>
          <p>
            AliTutor is operated by Ali Khalil as a sole proprietorship.
            AliTutor provides educational explanations, guided practice, and
            study support. No particular grade, test result, or academic outcome
            is guaranteed.
          </p>
        </section>

        <section>
          <span>02</span>
          <h2>Academic integrity</h2>
          <p>
            Tutoring supports your own learning. AliTutor will not impersonate a
            student, take an exam for a student, or complete work that must be
            submitted as the student’s independent work.
          </p>
        </section>

        <section>
          <span>03</span>
          <h2>Scheduling, payment, and cancellations</h2>
          <p>
            Session length, price, payment timing, rescheduling, and
            cancellation expectations will be confirmed before a paid session
            or package begins. Please provide accurate course and contact
            information when booking.
          </p>
        </section>

        <section>
          <span>04</span>
          <h2>Course and lesson materials</h2>
          <p>
            You are responsible for having permission to share course
            materials. AliTutor’s original lesson materials are for your
            personal study and may not be resold or publicly redistributed
            without permission.
          </p>
        </section>

        <section>
          <span>05</span>
          <h2>Questions</h2>
          <p>
            Questions about these terms can be sent to
            <a href="mailto:alifortutoring@gmail.com">alifortutoring@gmail.com</a>.
          </p>
        </section>

        <router-link class="legal-cta" to="/contact">
          Book a free consultation <span aria-hidden="true">↗</span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.legal-page {
  padding: clamp(6rem, 11vw, 10rem) 1.5rem;
  background: var(--paper);
  color: var(--ink);
}

.legal-shell {
  display: grid;
  grid-template-columns: 0.7fr 1.3fr;
  gap: clamp(3rem, 9vw, 9rem);
  width: min(1120px, 100%);
  margin: 0 auto;
}

.legal-intro {
  position: sticky;
  top: 130px;
  align-self: start;
}

.eyebrow {
  margin: 0 0 1.2rem;
  color: var(--blue);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  font-size: clamp(3.5rem, 7vw, 6.5rem);
  letter-spacing: -0.07em;
  line-height: 0.85;
}

.updated {
  margin: 1.8rem 0 0;
  color: #707889;
  font-size: 0.88rem;
}

.legal-content {
  border-top: 1px solid #d7dce6;
}

.legal-content section {
  position: relative;
  padding: 2.5rem 0 2.8rem 4rem;
  border-bottom: 1px solid #d7dce6;
}

.legal-content section > span {
  position: absolute;
  top: 2.9rem;
  left: 0;
  color: var(--blue);
  font-size: 0.72rem;
  font-weight: 800;
}

h2 {
  margin: 0 0 0.9rem;
  font-size: 1.45rem;
  letter-spacing: -0.035em;
}

.legal-content p {
  margin: 0;
  color: #515968;
  line-height: 1.8;
}

.legal-content a:not(.legal-cta) {
  color: var(--blue);
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.legal-cta {
  display: inline-flex;
  gap: 0.8rem;
  margin-top: 2.5rem;
  padding: 1rem 1.2rem;
  border-radius: 999px;
  background: var(--ink);
  color: white;
  font-weight: 800;
  transition: transform 180ms ease, background 180ms ease;
}

.legal-cta:hover {
  background: var(--blue);
  transform: translateY(-2px);
}

@media (max-width: 760px) {
  .legal-shell {
    grid-template-columns: 1fr;
  }

  .legal-intro {
    position: static;
  }

  .legal-content section {
    padding-left: 2.5rem;
  }
}
</style>
